<template>
    <!-- 签署协议页面 -->
    <div class="main">
    <h1>如未签署本协议 将无法使用您开通的会员服务</h1>
    <div class="box">
        <!-- 传参 或者 后端返回 -->
        <p>开通{{name}}的会员服务</p>
        <p>开通时长：{{ time }}</p>
        <p>支付金额：共计{{price}}元</p>
    </div>

    <div class="box box2">
        <h1>证券投资顾问业务风险揭示书</h1>
        <p v-html="text"></p>
    </div>


    <div class="btn" @click="goPage">我已阅读并同意以上内容</div>

  </div>
</template>

<script>
import "@/utils/flexible";
import {appversion,user_id,CURRENT_ENV_PRE } from "@/utils/urlQuery";
import goldApi from '@/api/gold/detail.js'

export default {
    data() {
        return {
            text:'',//证券投资顾问业务风险揭示书 内容 接口返回
            name:this.$route.query.name,//支付的老师名称
            time:this.$route.query.time,//支付的时间
            price:this.$route.query.price,  //支付的价格
            id:this.$route.query.id, //老师的agreement_id
            l_id:this.$route.query.l_id, //老师的l_id

            order:this.$route.query.order, //支付的订单号

        };
    },
    created() {
        console.log('price',this.$route)
        //获取签署协议
        this.getdata();   
    },
    mounted() {
        
    },
    methods:{
        async getdata() {
            //获取签署协议  agreement_id是老师的那个 agreement_id，从上一个页面传过来
            let res = await goldApi.warning({
                agreement_id:this.id,
                appversion:'11.9.0',
            });
            if(res.rslt == "succ") {
                this.text = res.content.replace(/\n/g, "\<br/>");
            }
        },
        goPage(){
            //确认 走到 实名认证页面
            location.href = `/up/app/vip_agreement?l_id=${this.l_id}&order=${this.order}&agreement_id=${this.id}`;
        }
    }
}
</script>

<style lang="scss" scoped>
.main{
    padding: 15px;
    box-sizing: border-box;
    height: 100vh;
    background: #F5F6F7;
    >h1{
        color:#FF4443;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
    }
    .btn{
        width: 100%;
        height: 41px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color:#fff;
        font-size: 17px;
        border-radius: 6px;
        background: #FF4443;
    }

    .box{
        border-radius: 6px;
        background: #FFF;
        padding: 12px 12px 2px;

        color: #939393;
        font-size: 14px;
        line-height: 20px;
        margin: 10px 0;

        >p{
            margin-bottom: 10px;
        }
    }

    .box2{
        color: #333;
        max-height: 66vh;
        overflow: scroll;
        h1{

            font-size: 15px;
            font-weight: bold;
            border-bottom: 1.5px solid #FF4443;
            padding-bottom: 12px;
            text-align: center;
            margin-bottom: 8px;
        }
    }
}

</style>